import React from "react";
import classnames from "classnames";
import styles from "./Image.module.scss";

function Image({ src, alt, circle, size = 52, shadow }) {
  const classNameResults = classnames(
    styles.image,
    circle && styles.circle,
    shadow && styles.shadow
  );
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={classNameResults}
    />
  );
}

export default Image;
